export const Avatar = ({ user, className = "w-9 h-9 text-sm", testId }) => (user?.picture
  ? <img data-testid={testId} src={user.picture} alt="" referrerPolicy="no-referrer" className={`${className} rounded-full object-cover shrink-0`} />
  : <div data-testid={testId} className={`${className} rounded-full bg-[var(--c-violet)] flex items-center justify-center font-display font-bold shrink-0`}>
    {(user?.name || user?.email || "?")[0].toUpperCase()}
  </div>);
